import { IoCloseSharp, IoFilter, IoSearchSharp } from "react-icons/io5";
import Button from "../../../components/Button/button";
import {
  BlueTitle,
  LoadingGif,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  StyledHR,
} from "../../../shared/styles/global.styles";
import {
  AppliedFilters,
  FilterItem,
  FilterKey,
  FilterRemoveButton,
  FiltersContainer,
  FilterValue,
} from "./styles";
import loadSCGif from "../../../assets/load_SC.gif";
import React, { useEffect, useRef, useState } from "react";
import {
  CreateManyInLoteFichaFinanceiraDto,
  FilterFichaFinanceiraDto,
  GetFinancialRecordDto,
  ResponseCreateManyInLoteFichaFinanceiraDto,
} from "../../../shared/dtos/FichaFinanceira.dto";
import {
  Table,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  MenuTableDivider,
  ButtonAction,
  MenuTable,
  MenuTableItem,
  TableContainer,
} from "../../../components/Table/styles";
import Pagination from "../../../components/Pagination/pagination";
import Swal from "sweetalert2";
import { Label } from "../../../components/Label/styles";
import {
  ContainerButtons,
  ContainerFilter,
  CustomTableContainer,
  LoadingContainer,
} from "./styles";
import InputComponent from "../../../components/Input/input";
import { Colors } from "../../../shared/colors/colors";
import { MdOutlineViewColumn } from "react-icons/md";
import { Accordion, Dropdown } from "react-bootstrap";
import {
  DropdownDivider,
  DropdownScroll,
} from "../../../components/Dropdowns/styles";
import TabelaFiltroModal from "../../../components/TabelaFiltroModal/TabelaFiltroModal";
import {
  formatarData,
  formatDateToBR,
} from "../../../utils/dateUtils/dateUtils";
import FichaFinanceiraService from "../../../services/FichaFinanceiraService";
import { IoMdClose } from "react-icons/io";
import { SlOptionsVertical } from "react-icons/sl";
import DetailsModal from "../../../components/DetalheModal/detalhe_modal";
import QrCodeModal from "../../../components/QRCodeModal/qrCode_modal";
import { set } from "cypress/types/lodash";
import {
  GetLogRetornoDto,
  GetLogRetornosGroupTypeDto,
} from "../../../shared/dtos/LogRetornos";
import logRetornosService from "../../../services/logRetornosService";
import {
  StatusImpressaoEnum,
  StatusParcelaEnum,
} from "../../../shared/enum/fichaFinanceira.enum";

interface Props {
  id: number;
  show: boolean;
  data: CreateManyInLoteFichaFinanceiraDto;
  onClose: () => void;
}

const ModalDetalhes: React.FC<Props> = ({ id, show, data, onClose }) => {
  const [searchValue, setSearchValue] = useState("");
  const [isOpen, setIsOpen] = useState<number | null>(null);
  const [showFiltroModal, setShowFiltroModal] = useState(false);
  const [appliedFilters, setAppliedFilters] =
    useState<FilterFichaFinanceiraDto>({});

  const [isSearch, setIsSearch] = useState(false);
  const [isRequest, setIsRequest] = useState<boolean>(false);
  const [isOpenMenuCollumn, setIsOpenMenuCollumn] = useState(false);
  const [tempVisibleColumns, setTempVisibleColumns] = useState<string[]>([]); // Estado temporário
  const [currentPage, setCurrentPage] = useState(1);
  const [totalParcelas, setTotalParcelas] = useState<number>(0);
  const [financialRecords, setFinancialRecords] = useState<
    GetFinancialRecordDto[]
  >([]);
  const [filteredRecords, setFilteredRecords] = useState<
    GetFinancialRecordDto[]
  >([]);
  const [logRetornos, setLogRetornos] =
    useState<GetLogRetornosGroupTypeDto[]>();
  const [
    fichaFinanceiraModalVisibleColumns,
    setFichaFinanceiraModalVisibleColumns,
  ] = useState<string[]>([]);
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(totalParcelas / itemsPerPage);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedRecord, setSelectedRecord] =
    useState<GetFinancialRecordDto | null>(null);
  const [showModalQRCode, setShowModalQRCode] = useState<boolean>(false);
  const [blobDetailsPDF, setBlobDetailsPDF] = useState<Blob>();

  const defaultColumns = [
    "Contribuinte",
    "Status parcela",
    "Nosso numero",
    "Tipo cobranca",
    "Valor parcela",
    "Vencimento",
  ];

  const loadVisibleColumns = () => {
    try {
      const savedColumns = sessionStorage.getItem(
        `fichaFinanceiraModalVisibleColumns`
      );
      if (!savedColumns)
        return setFichaFinanceiraModalVisibleColumns(defaultColumns);

      const parsedColumns = JSON.parse(savedColumns);
      setFichaFinanceiraModalVisibleColumns(
        parsedColumns.length > 0 ? parsedColumns : defaultColumns
      );
    } catch (error) {
      console.error("Erro ao carregar colunas:", error);
      return defaultColumns;
    }
  };

  const toggleDropdown = (id: number) => {
    setIsOpen(id === isOpen ? null : id);
  };

  const createBillOfPay = async (
    fichasFinanceiras: GetFinancialRecordDto[]
  ) => {
    const data = {
      idFichaFinanceira: fichasFinanceiras.map((fichas) => fichas.id),
    };

    try {
      Swal.fire({
        title: "Carregando",
        text: "Carregando boletos...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await FichaFinanceiraService.createBillOfPay(data);
      if (response.success) {
        // Abrir o PDF
        window.open(
          `${process.env.REACT_APP_API_URL}pdfs/${response.data.nameFile}`,
          "_blank"
        );

        // Aguardar 1 segundo antes de deletar (tempo para o navegador abrir o PDF)
        setTimeout(async () => {
          const deleteResponse = await FichaFinanceiraService.deleteFileInPdfs(
            response.data.nameFile
          );

          if (deleteResponse.success) {
            const firstResult = await Swal.fire({
              title: "Sucesso!",
              text: "Os boletos foram carregados com sucesso!",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          }
        }, 2000); // tempo em milissegundos
      } else {
        Swal.fire({
          title: "Erro",
          text: "Ocorreu um erro ao gerar o boleto. Por favor, tente novamente.",
          icon: "error",
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      }
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao gerar o PDF. Tente novamente.",
        icon: "error",
        allowOutsideClick: false,
      });
    }
  };

  const crateTableFichasData = (
    data: ResponseCreateManyInLoteFichaFinanceiraDto[]
  ) => {
    return (
      <Table
        style={{
          marginTop: 20,
          marginBottom: 40,
        }}
        firstColSmall={true}
        id="tabela-ficha-financeira"
      >
        <TableHead>
          <TableRow>
            {fichaFinanceiraModalVisibleColumns.includes("Contribuinte") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Contribuinte
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes("Status parcela") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Status parcela
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes("Parcela") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Parcela
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes(
              "Sequencial parcela"
            ) && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Sequencial parcela
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes("Nosso numero") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Nosso N°
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes("Tipo cobranca") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Tipo cobrança
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes("Valor parcela") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Valor Parcela
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes("Vencimento") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Vencimento
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes("Ajuste") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Ajuste
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes("Valor pago") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Valor pago
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes("Tarifa") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Tarifa
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes("Data pagamento") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Data pagamento
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes(
              "Status impressao"
            ) && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Status impressão
              </TableHeader>
            )}
            {fichaFinanceiraModalVisibleColumns.includes("Status remessa") && (
              <TableHeader
                style={{
                  textAlign: "center",
                }}
              >
                Status remessa
              </TableHeader>
            )}
            <TableHeader style={{ textAlign: "center" }}>Ações</TableHeader>
          </TableRow>
        </TableHead>
        <tbody>
          {data && data.length ? (
            data.map((record, index) =>
              record.ficha ? (
                <TableRow key={index}>
                  {fichaFinanceiraModalVisibleColumns.includes(
                    "Contribuinte"
                  ) && (
                    <TableData
                      style={{
                        textAlign: "start",
                      }}
                    >
                      {record.contribuinte.nome}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes(
                    "Status parcela"
                  ) && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {record.ficha.statusParcela}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes("Parcela") && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {record.ficha.sequencialParcela}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes(
                    "Sequencial parcela"
                  ) && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {record.ficha.sequencialParcela}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes(
                    "Nosso numero"
                  ) && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {record.ficha.nossoNumero}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes(
                    "Tipo cobranca"
                  ) && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {record.ficha.tipoCobranca}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes(
                    "Valor parcela"
                  ) && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(Number(record.ficha.valorParcela))}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes(
                    "Vencimento"
                  ) && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {record.ficha.dataVencimento
                        ? formatarData(record.ficha.dataVencimento as string)
                        : "-"}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes("Ajuste") && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {Number(record.ficha.valorAjuste) < 0
                        ? `- R$ ${new Intl.NumberFormat("pt-BR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(
                            Math.abs(Number(record.ficha.valorAjuste))
                          )}`
                        : new Intl.NumberFormat("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          }).format(Number(record.ficha.valorAjuste))}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes(
                    "Valor pago"
                  ) && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(Number(record.ficha.valorPago))}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes("Tarifa") && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(Number(record.ficha.valorTarifa))}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes(
                    "Data pagamento"
                  ) && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {record.ficha.dataPagamento
                        ? formatarData(record.ficha.dataPagamento as string)
                        : "-"}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes(
                    "Status impressao"
                  ) && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {record.ficha.statusImpressao}
                    </TableData>
                  )}
                  {fichaFinanceiraModalVisibleColumns.includes(
                    "Status remessa"
                  ) && (
                    <TableData
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {record.ficha.statusRemessa}
                    </TableData>
                  )}
                  <TableData
                    style={{
                      position: "relative",
                      overflow: "visible",
                    }}
                  >
                    <ButtonAction
                      onClick={() => toggleDropdown(record.ficha.id)}
                      style={{
                        marginLeft: "auto",
                      }}
                    >
                      {isOpen === record.ficha.id ? (
                        <IoMdClose
                          cursor={"pointer"}
                          size={20}
                          style={{
                            color: Colors.primary,
                          }}
                        />
                      ) : (
                        <SlOptionsVertical
                          cursor={"pointer"}
                          size={20}
                          style={{
                            color: Colors.primary,
                          }}
                        />
                      )}
                    </ButtonAction>
                    <MenuTable
                      style={{
                        right: filteredRecords.length === 1 ? "80%" : "",
                        bottom:
                          filteredRecords.length === 1
                            ? filteredRecords.length * -19
                            : "",
                      }}
                      show={isOpen === record.ficha.id}
                      align="start"
                      isLastRows={
                        filteredRecords.indexOf(record.ficha) === 0
                          ? true
                          : filteredRecords.length > 0 &&
                            filteredRecords.indexOf(record.ficha) >=
                              filteredRecords.length -
                                Math.ceil(filteredRecords.length / 2)
                      }
                      ref={(el: HTMLDivElement | null) => {
                        // Armazena a referência no mapa usando o ID do registro como chave
                        menuRefsMap.current.set(record.ficha.id, el);
                      }}
                    >
                      <MenuTableItem
                        onClick={() => {
                          setSelectedRecord(record.ficha);
                          setShowDetailsModal(true);
                          setIsOpen(null);
                        }}
                      >
                        Ver Parcela
                      </MenuTableItem>
                      <MenuTableDivider />
                      {record.ficha.statusParcela !==
                        StatusParcelaEnum.CANCELADA &&
                        record.ficha.statusImpressao !==
                          StatusImpressaoEnum.NAO_IMPRIMIR &&
                        record.ficha.statusImpressao !==
                          StatusImpressaoEnum.PENDENTE && (
                          <>
                            <MenuTableItem
                              onClick={() => {
                                createBillOfPay([record.ficha]);
                                setIsOpen(null);
                              }}
                            >
                              Imprimir
                            </MenuTableItem>
                            <MenuTableDivider />
                          </>
                        )}

                      {record.ficha.statusParcela !==
                        StatusParcelaEnum.CANCELADA &&
                        record.ficha.qrCodePix &&
                        record.ficha.qrCodePix !== "" && (
                          <>
                            <MenuTableItem
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedRecord(record.ficha);
                                setShowModalQRCode(true);
                                setIsOpen(null);
                              }}
                            >
                              Detalhes do PIX
                            </MenuTableItem>
                            <MenuTableDivider />
                          </>
                        )}
                    </MenuTable>
                  </TableData>
                </TableRow>
              ) : (
                <TableRow key={index}>
                  <TableData
                    colSpan={fichaFinanceiraModalVisibleColumns.length + 1}
                    style={{ textAlign: "center" }}
                  >
                    Nenhum Detalhe Disponível
                  </TableData>
                </TableRow>
              )
            )
          ) : (
            <tr>
              <TableData
                className="text-center text-muted"
                colSpan={fichaFinanceiraModalVisibleColumns.length + 1}
              >
                Nenhuma parcela cadastrada.
              </TableData>
            </tr>
          )}
        </tbody>
      </Table>
    );
  };

  const getPdfFile = async (pdfName: string) => {
    if (pdfName === "" || blobDetailsPDF || isRequest) {
      return;
    }

    setIsRequest(true);
    const getPdfResponse = await fetch(
      `${process.env.REACT_APP_API_URL}pdfs/${pdfName}`
    ).then((response) => {
      if (!response.ok) {
        console.error(`Erro ao carregar o PDF: ${response.statusText}`);
        return null;
      }
      return response;
    });
    if (!getPdfResponse) {
      Swal.fire({
        title: "Erro",
        text: "Erro ao carregar o PDF",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
    const pdfBlobDetailsData = await getPdfResponse.blob();
    setBlobDetailsPDF(pdfBlobDetailsData);

    await FichaFinanceiraService.deleteFileInPdfs(pdfName)
      .then(() => {
        setIsRequest(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const imprimirRelatorio = async (pdf: Blob) => {
    try {
      const url = URL.createObjectURL(pdf);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.focus();
      }
      // Revoga a URL após um pequeno atraso
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      return;
    } catch (error) {
      console.error("Erro ao processar o PDF:", error);
    } finally {
      // Garante que o foco volte para a janela principal
      window.focus();
    }
  };

  useEffect(() => {
    loadVisibleColumns();
  }, [id, show]);

  useEffect(() => {
    if (data.nameFileDetails && !blobDetailsPDF) {
      getPdfFile(data.nameFileDetails);
    }
  }, [data]);

  useEffect(() => {
    // Função para fechar o menu se o clique for fora dele
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownMenuRef.current &&
        !dropdownMenuRef.current.contains(event.target as Node)
      ) {
        setIsOpenMenuCollumn(false); // Fecha o dropdown
      }
    };

    // Adiciona o event listener quando o menu estiver aberto
    if (isOpenMenuCollumn) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Limpeza do event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpenMenuCollumn]);

  useEffect(() => {
    if (isOpenMenuCollumn) {
      setTempVisibleColumns(fichaFinanceiraModalVisibleColumns);
    }
  }, [isOpenMenuCollumn, fichaFinanceiraModalVisibleColumns]);
  const menuRefsMap = useRef<Map<number, HTMLDivElement | null>>(new Map());
  return (
    <ModalContainer show={show}>
      <ModalContent width={65} height={90}>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => onClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>Detalhes do cadastro de parcelas</BlueTitle>
        </ModalHeader>
        <ModalBody>
          <>
            {blobDetailsPDF && (
              <Button
                schemaButton="out-primary"
                action={() => imprimirRelatorio(blobDetailsPDF)}
                disabled={isRequest}
              >
                Imprimir detalhes da criação de fichas
              </Button>
            )}
            <TableContainer>
              {isRequest ? (
                <LoadingContainer>
                  <LoadingGif src={loadSCGif} alt="Carregando..." />
                </LoadingContainer>
              ) : (
                <>
                  {data ? (
                    <Accordion>
                      <Accordion.Item eventKey={"1"}>
                        <Accordion.Header>
                          Parcelas Criadas - Total: {data.criados?.length}
                        </Accordion.Header>
                        <Accordion.Body>
                          {crateTableFichasData(data.criados)}
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey={"2"}>
                        <Accordion.Header>
                          Possui ficha financeira - Total:{" "}
                          {data.possuiFicha?.length}
                        </Accordion.Header>
                        <Accordion.Body>
                          {crateTableFichasData(data.possuiFicha)}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ) : (
                    <BlueTitle>Nenhuma parcela foi cadastrada</BlueTitle>
                  )}
                </>
              )}
            </TableContainer>
          </>

          {selectedRecord && (
            <>
              <DetailsModal
                show={showDetailsModal}
                onClose={() => setShowDetailsModal(false)}
                record={selectedRecord}
                setShowQrCodeModal={setShowModalQRCode}
              />
              <QrCodeModal
                show={showModalQRCode}
                onClose={() => setShowModalQRCode(false)}
                qrCode={selectedRecord?.qrCodePix}
              />
            </>
          )}
        </ModalBody>
      </ModalContent>
    </ModalContainer>
  );
};

export default ModalDetalhes;
